import React, { useMemo } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { useFormikContext } from 'formik';
import SelectField from 'Shared/form/SelectField';
import { addReferralActivityBiPlan } from 'App/services/RMSService';
import { uniqBy } from 'lodash';
import { queryClient } from 'Shared/queryClient';

const attachNewPlan = '+add new plan';

function AttachInsurancePlan() {
    const { patientId, referralId, benefitsInvestigationId: activityId } = useParams();

    const { values, setFieldValue, validateForm, setFormikState } = useFormikContext();
    const { allActiveInsurance, disableInputs, patientInsurance } = values;
    const addInsurancePlanOptions = useMemo(() => {
        const options = [
            {
                label: '+Add New Plan',
                value: attachNewPlan,
            },
        ];

        const piIds = patientInsurance.map((it) => it.uuid);
        const diffList = allActiveInsurance.filter((it) => !piIds.includes(it.uuid));
        const insuranceDifference = uniqBy(diffList, 'uuid');
        if (insuranceDifference) {
            insuranceDifference.forEach((it) => {
                options.push({
                    label: it.name,
                    value: it.id,
                });
            });
        }
        return options;
    }, [patientInsurance, allActiveInsurance]);

    const onChangeHandler = ({ value: selectOption }) => {
        if (selectOption === attachNewPlan) {
            let max = 0;
            for (const item of [...patientInsurance, ...allActiveInsurance]) {
                if (item.position >= max) {
                    max = item.position;
                }
            }
            setFieldValue('patientInsurance', [
                ...patientInsurance,
                {
                    position: max + 1,
                },
            ]);
            setImmediate(() => validateForm());
        } else {
            const selectedInsurance = (allActiveInsurance || []).find((it) => it.id === selectOption);
            if (selectedInsurance) {
                const updatedValues = {
                    ...values,
                    patientInsurance: [...patientInsurance, selectedInsurance],
                };
                setFormikState((prevState) => ({
                    ...prevState,
                    initialValues: updatedValues,
                    values: updatedValues,
                }));
                addReferralActivityBiPlan(
                    patientId,
                    [selectedInsurance.uuid],
                    parseInt(referralId, 10),
                    parseInt(activityId, 10)
                ).then(() => {
                    queryClient.invalidateQueries(['patient', patientId, 'insurance']);
                    queryClient.invalidateQueries(['patient', patientId, 'biInsurance']);
                });
            }
        }
    };

    return (
        <Row>
            <Col md={3}>
                <SelectField
                    className="form-control insurance-field"
                    name="attachInsurance"
                    fieldName="attachInsurance"
                    label="Attach Insurance Plan(s)"
                    options={addInsurancePlanOptions}
                    onChange={onChangeHandler}
                    isClearable
                    isDisabled={disableInputs}
                />
            </Col>
        </Row>
    );
}

export default AttachInsurancePlan;
